import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-full-width-separator',
  templateUrl: './full-width-separator.component.html',
  styleUrls: ['./full-width-separator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullWidthSeparatorComponent {}
